<div (click)="redirect()">
    <div
        class="tw-flex tw-justify-between tw-items-center tw-pb-2 tw-border-gray-200"
        [ngClass]="!isDropdownOpen && 'tw-border-b-[1px]'"
        (click)="toggleDropdown(!isDropdownOpen)"
    >
        <div class="tw-font-semibold tw-text-lg tw-cursor-pointer">
            {{ label | translate }}
        </div>
        <div *ngIf="dropDown">
            <mat-icon *ngIf="!isDropdownOpen">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="isDropdownOpen">keyboard_arrow_up</mat-icon>
        </div>
    </div>
    <div
        class="{{
            'tw-flex tw-flex-col tw-gap-2  tw-text-gray-400 ' +
                (borderBottom
                    ? 'tw-pb-6 tw-border-b-[1px]  tw-border-gray-100 '
                    : '') +
                (isDropdownOpen
                    ? 'tw-h-auto tw-opacity-100'
                    : 'tw-h-0 tw-opacity-0 tw-overflow-hidden')
        }}"
    >
        <div
            class="tw-pt-1"
            *ngFor="
                let dropdownValue of dropdownValues;
                let dropDownIndex = index
            "
        >
            <div
                [attr.ga-event-id]="dropdownValue.ga_event_id"
                [attr.ga-event-category]="dropdownValue.ga_event_category"
                [attr.ga-event-label]="dropdownValue.ga_event_label"
                ga-track="track"
                class="tw-text-black tw-font-normal tw-pr-16 tw-flex tw-justify-between"
                (click)="router.navigate([dropdownValue.href])"
            >
                <div class="tw-cursor-pointer">
                    {{ dropdownValue.label | translate }}
                </div>
                <div
                    *ngIf="dropdownValue.hasBadge"
                    class="tw-flex tw-items-center tw-font-semibold tw-text-xs tw-py-1 tw-px-3 tw-rounded-full tw-max-h-[26px] tw-bg-[#FFB449] tw-text-white"
                >
                    {{ "COMMON.NEW" | translate }}
                </div>
                <div
                    *ngIf="
                        dropdownValue.subValues &&
                        dropdownValue.subValues.length > 0
                    "
                    class="{{
                        ' tw-bg-[#F5F0EB] tw-px-4  tw-rounded-xl ' +
                            (subDropDownOpen[dropDownIndex]
                                ? 'tw-h-auto tw-opacity-100'
                                : 'tw-h-0 tw-opacity-0 tw-overflow-hidden')
                    }}"
                >
                    <div
                        *ngFor="
                            let subValues of dropdownValue.subValues;
                            let i = index
                        "
                        class="tw-pt-2 tw-pb-4 tw-mt-2"
                    >
                        <div class="tw-pt-1">
                            <div
                                class="tw-font-semibold tw-text-black tw-py-2 tw-cursor-pointer"
                            >
                                {{ subValues.label | translate }}
                            </div>
                            <div class="tw-text-sm tw-text-gray-600">
                                {{ subValues.description | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
